import { useEffect } from 'preact/hooks'

export function useKeyboard(
  onOpen: () => void,
  onClose: () => void,
  isOpen: boolean,
) {
  useEffect(() => {
    function handler(e: KeyboardEvent) {
      const isKKey = e.key === 'k' || e.key === 'K'
      const isMod = e.metaKey || e.ctrlKey

      if (isKKey && isMod) {
        e.preventDefault()
        isOpen ? onClose() : onOpen()
        return
      }

      if (e.key === 'Escape' && isOpen) {
        onClose()
      }
    }

    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [isOpen, onOpen, onClose])
}
